/**
 * Home hero shuffle: three columns on desktop, one on mobile (max-width 989px).
 * One column at a time crossfades to a new image; columns advance in round-robin.
 */
(function () {
  const MIN_MS = 2000;
  const MAX_MS = 4500;
  const MOBILE_MQ = '(max-width: 989px)';

  function randBetween(min, max) {
    return min + Math.random() * (max - min);
  }

  function shuffle(arr) {
    const a = arr.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  function getColumnCount() {
    return window.matchMedia(MOBILE_MQ).matches ? 1 : 3;
  }

  function getFrames(root, columnCount) {
    const links = root.querySelectorAll('.gearby-home__slide-link');
    if (columnCount === 1) {
      const frame = links[0] && links[0].querySelector('[data-shuffle-frame]');
      return frame ? [frame] : [];
    }
    return Array.from(root.querySelectorAll('[data-shuffle-frame]'));
  }

  /** Next image: not this column's current, not shown in sibling columns; fair among eligible by usage. */
  function pickNextIndexUnique(urls, usage, state, col, columnCount) {
    const cur = state[col].index;
    const banned = new Set([cur]);
    if (columnCount >= 2) banned.add(state[(col + 1) % columnCount].index);
    if (columnCount >= 3) banned.add(state[(col + 2) % columnCount].index);

    const pool = [];
    for (let i = 0; i < urls.length; i++) {
      if (!banned.has(i)) pool.push(i);
    }
    if (pool.length === 0) return null;

    let minUse = Infinity;
    for (let pi = 0; pi < pool.length; pi++) {
      minUse = Math.min(minUse, usage[pool[pi]]);
    }
    const best = [];
    for (let pi = 0; pi < pool.length; pi++) {
      const i = pool[pi];
      if (usage[i] === minUse) best.push(i);
    }
    return best[Math.floor(Math.random() * best.length)];
  }

  function init(root) {
    const jsonId = root.getAttribute('data-carousel-json');
    if (!jsonId) return;
    const el = document.getElementById(jsonId);
    if (!el || !el.textContent) return;

    let urls;
    try {
      urls = JSON.parse(el.textContent);
    } catch (_) {
      return;
    }
    if (!Array.isArray(urls) || urls.length < 4) return;

    const columnCount = getColumnCount();
    const frames = getFrames(root, columnCount);
    if (frames.length !== columnCount) return;
    for (let fi = 0; fi < frames.length; fi++) {
      if (frames[fi].querySelectorAll('.gearby-home__shuffle-layer').length !== 2) return;
    }

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const usage = urls.map(() => 0);
    const state = [];

    const order = shuffle(urls.map((_, i) => i));
    frames.forEach((frame, col) => {
      const layers = frame.querySelectorAll('.gearby-home__shuffle-layer');
      if (layers.length !== 2) return;
      const idx = order[col % order.length];
      usage[idx] += 1;
      layers[0].src = urls[idx];
      layers[0].classList.add('is-visible');
      layers[0].setAttribute('aria-hidden', 'false');
      layers[1].removeAttribute('src');
      layers[1].classList.remove('is-visible');
      layers[1].setAttribute('aria-hidden', 'true');
      state[col] = { index: idx, visible: 0 };
    });

    if (reduceMotion) return;

    let timer;
    let nextCol = Math.floor(Math.random() * columnCount);

    function applySwap(col) {
      const nextIdx = pickNextIndexUnique(urls, usage, state, col, columnCount);
      if (nextIdx === null) return;

      const frame = frames[col];
      const layers = frame.querySelectorAll('.gearby-home__shuffle-layer');
      const vis = layers[state[col].visible];
      const hid = layers[1 - state[col].visible];

      const finalize = () => {
        vis.classList.remove('is-visible');
        vis.setAttribute('aria-hidden', 'true');
        hid.classList.add('is-visible');
        hid.setAttribute('aria-hidden', 'false');
        state[col].visible = 1 - state[col].visible;
        state[col].index = nextIdx;
        usage[nextIdx] += 1;
      };

      hid.onload = () => {
        hid.onload = null;
        window.requestAnimationFrame(() => {
          finalize();
        });
      };

      hid.src = urls[nextIdx];
      if (hid.complete && hid.naturalWidth > 0) {
        hid.onload = null;
        window.requestAnimationFrame(finalize);
      }
    }

    function tick() {
      const col = nextCol;
      nextCol = (nextCol + 1) % columnCount;
      applySwap(col);
      timer = window.setTimeout(tick, randBetween(MIN_MS, MAX_MS));
    }

    timer = window.setTimeout(tick, randBetween(MIN_MS, MAX_MS));

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        window.clearTimeout(timer);
        timer = null;
      } else if (!timer) {
        timer = window.setTimeout(tick, randBetween(MIN_MS, MAX_MS));
      }
    });
  }

  document.querySelectorAll('[data-gearby-home-carousel]').forEach(init);
})();
